<template>
  <span>
    <v-row>
      <v-col class="pb-0">
        <v-autocomplete
          @change="handleServiceTypeChange"
          v-model="autocompleteValue"
          :items="availableItemsForSelection"
          :no-data-text="emptyMessage"
          :label="labels.services"
          :hint="labels.selectServiceTypes"
          hide-details="auto"
          persistent-hint
          clearable
          outlined
        >
          <template v-slot:selection="{ item }">
            {{ $t(`appointment.type.${item}`) }}
          </template>
          <template v-slot:item="{ item }">
            {{ $t(`appointment.type.${item}`) }}
          </template>
        </v-autocomplete>
      </v-col>
    </v-row>
    <v-card class="pa-5 mb-2" elevation="0" color="grey lighten-3">
      <p v-if="isServiceTypeSelectedEmpty" class="body-2 text-center grey--text text--darken-2 mb-0">
        {{ labels.noServiceTypesSelected }}
      </p>
      <div v-for="item in selectedServiceTypes" :key="item" class="d-flex space-between">
        <span class="body-2 grey--text text--darken-2">
          {{ $t(`appointment.type.${item}`) }}
        </span>
        <v-icon @click="removeServiceType(item)" class="ml-2" small>
          mdi-close-circle-outline
        </v-icon>
      </div>
    </v-card>
  </span>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'ServiceTypesSelection',

  props: {
    realEstateId: {
      type: String,
      required: false,
    },

    currentServiceTypes: {
      type: Array,
      required: false,
    },
  },

  methods: {
    ...mapActions([
      'fetchActiveServiceTypes',
    ]),

    removeServiceType(item) {
      this.selectedServiceTypes = this.selectedServiceTypes.filter(service => service !== item)
      this.$emit('update:service-types', this.selectedServiceTypes)
      this.autocompleteValue = null
    },

    handleServiceTypeChange(value) {
      if (!value) return
      this.selectedServiceTypes.push(value)
      this.$emit('update:service-types', this.selectedServiceTypes)
      this.autocompleteValue = null
    },
  },

  computed: {
    ...mapGetters([
      'activeServiceTypes',
      'availableServiceTypes',
      'isServiceTypeSelectedEmpty',
    ]),

    isServiceTypeSelectedEmpty() {
      return this.selectedServiceTypes.length === 0
    },

    availableItemsForSelection() {
      if (!this.activeServiceTypes || !Array.isArray(this.activeServiceTypes)) return []

      return this.activeServiceTypes.filter(
        (item) => !this.selectedServiceTypes.includes(item)
      )
    },

    emptyMessage() {
      if (this.isServiceTypeSelectedEmpty) {
        return this.labels.noServiceTypesSelected
      }

      return this.labels.allServiceTypesSelected
    },
  },

  data() {
    return {
      labels: {
        services: this.$t('hausefulUsers.label.services'),
        selectServiceTypes: this.$t('hausefulUsers.messages.selectServiceTypes'),
        selectServiceTypes: this.$t('hausefulUsers.messages.selectServiceTypes'),
        noServiceTypesSelected: this.$t('hausefulUsers.messages.noServiceTypesSelected'),
        noActiveServiceTypes: this.$t('hausefulUsers.messages.noActiveServiceTypes'),
        allServiceTypesSelected: this.$t('hausefulUsers.messages.allServiceTypesSelected'),
      },

      autocompleteValue: null,
      selectedServiceTypes: [],
      inspectorServiceTypes: [],
    }
  },

  async mounted() {
    await this.fetchActiveServiceTypes(this.realEstateId)
    this.selectedServiceTypes = [...this.currentServiceTypes]
  },
}
</script>
